export default {
  name: '',
  description: '',
  domain: '',
};
